import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import styled from "styled-components";
import { MODAL_STYLES } from "../constants";

const ModalHeader = styled.div`
  background: #CE0E2D;
  color: white;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 1em;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.4em;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
`;

const ModalBody = styled.div`
  padding: 20px 20px 24px;
  text-align: center;
`;

const BodyText = styled.p`
  margin: 0;
  line-height: 1.6;
  font-size: 0.95em;
  color: #333;
`;

const ButtonRow = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
  gap: 24px;
`;

const ConfirmBtn = styled.button`
  background: #CE0E2D;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 7px 18px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #a30b24;
  }
`;

const CancelBtn = styled.button`
  background: white;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 7px 18px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f3f4f6;
    border-color: #999;
    color: #333;
  }
`;

export const WarningMessage = ({
  isModalOpen,
  confirmChange,
  cancelChange,
  filterName,
}) => {
  return (
    <ReactModal
      isOpen={isModalOpen}
      onRequestClose={cancelChange}
      contentLabel="Confirm Division Change"
      style={MODAL_STYLES}
      appElement={document.getElementById("root")}
    >
      <ModalHeader>
        Unsaved Changes
        <CloseButton onClick={cancelChange}>&times;</CloseButton>
      </ModalHeader>
      <ModalBody>
        <BodyText>
          <strong>You have unsaved changes!</strong>
          <br />
          Changing the {filterName} will{" "}
          <strong>remove all unsaved changes</strong>.
          <br />
          Are you sure you want to change the {filterName}?
        </BodyText>
      </ModalBody>
      <ButtonRow>
        <CancelBtn onClick={cancelChange}>No, Go Back</CancelBtn>
        <ConfirmBtn onClick={confirmChange}>Yes, Continue</ConfirmBtn>
      </ButtonRow>
    </ReactModal>
  );
};

WarningMessage.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  confirmChange: PropTypes.func.isRequired,
  cancelChange: PropTypes.func.isRequired,
  filterName: PropTypes.string,
};
